__turbopack_context__.v({
  "chip": "Default-module__neGZGq__chip",
  "chipCloseIcon": "Default-module__neGZGq__chipCloseIcon",
  "chipSelected": "Default-module__neGZGq__chipSelected",
  "choice": "Default-module__neGZGq__choice",
  "disabled": "Default-module__neGZGq__disabled",
  "filter": "Default-module__neGZGq__filter",
  "leftIcon_choice": "Default-module__neGZGq__leftIcon_choice",
  "leftIcon_filter": "Default-module__neGZGq__leftIcon_filter",
  "rightIcon_choice": "Default-module__neGZGq__rightIcon_choice",
  "rightIcon_filter": "Default-module__neGZGq__rightIcon_filter",
  "xl": "Default-module__neGZGq__xl",
  "xxl": "Default-module__neGZGq__xxl",
});
